import React, {useState, Fragment, useEffect} from 'react';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { Card, CardContent } from '@mui/material';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { Cancel, Save } from '@mui/icons-material';
import Formulario from 'components/formulario';
import { useSelector, useDispatch } from 'react-redux';
import { functions } from 'constantes/functions';
import {nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPersonalizado } from 'store/actions/customAction';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { nombreDeAcciones } from 'constantes';

let nitEmpresa = "";
const NuevaVallaMovil= ({title, openFullScreenDialog, handleClose, datosDeEmpresa, datosGeneralesDelTarifario, datosEditados}) => {
  const {datosGenerales} = useSelector((state) => state);
  const dispatch = useDispatch();
  const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const [mostrarAlertaDeErrorOExito, setMostrarAlertaDeErrorOExito] = useState(false);
  const [tarifarioDeVallasMoviles] = useState('tarifarioDeVallasMoviles');
  const [catalogoTipoDeTransporte] = useState('catalogoTipoDeTransporte');
  nitEmpresa = datosDeEmpresa?.nit;
  const [respuestDeExito, setRespuestaDeExito] = useState("");

  useEffect(() => {
    obtenerTipoDeTransporte()
  },[])

  const obtenerTipoDeTransporte = async () => {
    const copiaDeCampos = Object.assign({}, camposDelFormulario);

    if(datosGenerales.tipoDeTransporte.length > 0) {
        copiaDeCampos.tipoDeTransporte.list = datosGenerales.tipoDeTransporte?.map( ({id, descripcion}) => ({id, name: descripcion}) );
        return setCamposDelFormulario(copiaDeCampos);
    }

    setcargandoSolicitud(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: catalogoTipoDeTransporte,
        validateIfDataExists: true,
        stateInStore: datosGenerales.tipoDeTransporte,
        dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_TRANSPORTE,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    copiaDeCampos.tipoDeTransporte.list = respuesta?.data?.map( ({id, descripcion}) => ({id, name: descripcion}) )
    setCamposDelFormulario(copiaDeCampos);
  }

  const {esMovil, unaVallaEnUnidad, costo, tipoDeTransporte, altoValla, anchoValla, imagenDeRuta, descripcionRuta, medioDeComunicacion} = datosGeneralesDelTarifario;

  const [camposDelFormulario, setCamposDelFormulario] = useState({
    titulodeValla:{
        idelement: "titulodeValla", title:'¿Qué tipo de móvil es? *', position:"center", elementType:'titulo', showTitleForm: true, name: "titulodeValla", value: "", isError:false,
    },
    tipoDeMovil:{
      idelement: "tipoDeMovil", value: medioDeComunicacion?.id ? esMovil ? 1 : 2 : "", label: "¿Qué tipo de móvil es? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [{value: 1, label: "MÓVIL DIGITAL"}, {value: 2, label: "MÓVIL FÍSICA"}], 'disabled':false, isRequired: true,
    },
    tituloCantidadValla:{
        idelement: "tituloCantidadValla", title:'¿Cuántas vallas tiene la unidad? *', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloCantidadValla", value: "", isError:false, width: '30%',
    },
    cantidadValla:{
      idelement: "cantidadValla", value: medioDeComunicacion?.id ? unaVallaEnUnidad ? 1 : 2 : "", label: "¿Cuántas vallas tiene la unidad? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [{value: 1, label: "UNA"}, {value: 2, label: "DOS"}], 'disabled':false, isRequired: true,
    },
    tituloTarifaComercial:{
      idelement: "tituloTarifaComercial", title:'Tarifa Comercial', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloTarifaComercial", value: "", isError:false,
    },
      alertaTarifa:{
        idelement: "alertaTarifa", mensaje:'LA TARIFA COMERCIAL NO DEBE SUPERAR EL PROMEDIO DE LA TARIFA COMERCIAL DEBE SER INGRESADA EN QUETZALES (Q) DEBE INCLUIR IVA Y TIMBRE DE PRENSA', elementType:'alerta', showAlertForm: true, name: "alertaTarifa", value: "", isError:false, severity: 'error'
      },
      costoDeValla: {
        idelement: "costoDeValla", value: costo || "", label: `Costo de la valla *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números o números con decimales'], isError:false, elementType:'texto', name:"costoDeValla", 'disabled': false, width: '50%',
      },
      tituloDimensiones:{
          idelement: "tituloDimensiones", title:'Dimensiones', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDimensiones", value: "", isError:false,
      },
      tituloTipoVallaMovil:{
          idelement: "tituloTipoVallaMovil", title:'Tipo de transporte', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloTipoVallaMovil", value: "", isError:false, widthTitleForm: '90%'
      },
      tipoDeTransporte: {
        idelement: "tipoDeTransporte", value: tipoDeTransporte ? {id: tipoDeTransporte?.id, name: tipoDeTransporte?.descripcion} : null, label: "Seleccione el tipo de transporte *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '50%', marginTop: '10px'
      },
      tituloTipoDeValla:{
        idelement: "tituloTipoDeValla", title:'Vallas(s)', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloTipoDeValla", value: "", isError:false, widthTitleForm: '90%'
      },
      anchoValla: {
          idelement: "anchoValla", value: anchoValla || "", label: `Ancho (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"anchoValla", 'disabled': false, width: '45%',
      },
      altoValla: {
          idelement: "altoValla", value: altoValla || "", label: `Alto (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"altoValla", 'disabled': false, width: '45%',
      },
      tituloRuta:{
        idelement: "tituloRuta", title:'Ruta', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloRuta", value: "", isError:false, widthTitleForm: '100%'
      },
      imagenDeLaValla:{
        idelement: "imagenDeLaValla", value: imagenDeRuta ? imagenDeRuta.includes('base64,') ? imagenDeRuta : `data:image/jpeg;base64,${imagenDeRuta}` : "", label: "Imagen de la ruta", validators: {required: true, size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"imagenDeLaValla", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '30%', type: "file"
      },
      descripcionDeRuta:{
        idelement: "descripcionDeRuta", value: descripcionRuta || "", label: `Descripción de la ruta`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”()-*_/@]{4,2000}$", validators: ['required'],
        errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionDeRuta", width: '100%'
      },
      acciones: {
          idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
      },
  });

  const guardarDatos = async (dataForm) => {

    setcargandoSolicitud(true);

    const {tipoDeMovil, cantidadValla, costoDeValla, tipoDeTransporte, anchoValla, altoValla, imagenDeLaValla, descripcionDeRuta} = dataForm;

    const datosAGuardar = {
      tipoDeTransporte: tipoDeTransporte?.id || "",
      altoValla,
      anchoValla,
      "costo": costoDeValla,
      "descripcionRuta": descripcionDeRuta,
      "dosVallasEnUnidad": Number(cantidadValla) === 2,
      "unaVallaEnUnidad": Number(cantidadValla) === 1,
      "esFija": Number(tipoDeMovil) === 2,
      "esMovil": Number(tipoDeMovil) === 1,
      "nitEmpresa": nitEmpresa,
      imagenRuta: imagenDeLaValla
    }

    let datosAEnviar = {};
    let response = {};

    if(medioDeComunicacion?.id) {
        datosAGuardar.idMedioDeComunicacion = medioDeComunicacion?.id
        datosAEnviar = { controller: tarifarioDeVallasMoviles, action: 'editar', data: datosAGuardar, nombreDelMetodo: "editar/informacionGeneral" };
        response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
    } else {
        datosAEnviar = { controller: tarifarioDeVallasMoviles, action: 'crear', data: datosAGuardar };
        response = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
    }
    setcargandoSolicitud(false);

    if(response?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: response.error?.message || "REGISTRO NO INGRESADO. INTENTE NUEVAMENTE", mostrarRespuesta: true, });

    if(medioDeComunicacion?.id) return datosEditados(response?.data?.data)

    setRespuestaDeExito(response?.data?.data)
    setMostrarAlertaDeErrorOExito(true);
  }
    const [listadoDeBotones]= useState({
        "guardarDatos":{"label":"Guardar", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

  const handClose = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => {
      setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})
  };

  const manejadorAccionDelModal = async () => {
    functions.reiniciarEstadoDelFormulario(camposDelFormulario)
    setMostrarAlertaDeErrorOExito(false);
  }

  const cerrarAlertaDeConfirmacion = () => {
    handleClose(true)
    setMostrarAlertaDeErrorOExito(false);
  }

  const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={handleClose}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
          <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
          <Card>
              <CardContent>
                <Formulario
                  elements={camposDelFormulario}
                  buttonList={listadoDeBotones}
                />
              </CardContent>
          </Card>
          {mostrarAlertaDeErrorOExito && (
                <ModalDeConfirmacion
                    title={`¿Desea agregar otra valla móvil?`} message={respuestDeExito || "¡REGISTRADO CORRECTAMENTE!"}
                    open={mostrarAlertaDeErrorOExito} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, agregar"}
                    actionAdd={manejadorAccionDelModal}
                />
          )}
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default NuevaVallaMovil;